import { OutschoolCard } from 'us-react-components/dist/OutschoolCard/OutschoolCard';
import { useDependencies } from '../../../dependencies';

// Mirrors outschool-search-card.js — thin wrapper that hands the
// tracking callback through. Visibility (page 1 + teaching-skill / tutoring
// filter) is decided by the parent so the container doesn't need to know
// which search it's embedded in.
export const OutschoolWidget = (): JSX.Element => {
  const { services: { tracker } } = useDependencies();
  return (
    <OutschoolCard
      trackingCallback={(event, params): Promise<void> => tracker.track(event, params)}
    />
  );
};
